import api from "./http";

export const ApiAlumni = {
    getByKey : (key) =>{
        return api.get(`/santri/search/alumni/${key}`)
    }
}